import registered from './hooks/registered';
import store from './store';
const screen = {
    name: 'idg-global',
    registered,
    store,
};
export default screen;
